import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { InvoiceService } from 'src/app/services/invoice.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-xml-dnit-resend',
  templateUrl: './xml-dnit-resend.component.html',
  styleUrls: ['./xml-dnit-resend.component.scss'],
  providers: [InvoiceService, UtilsService]
})
export class XmlDnitResendComponent implements OnInit {
  @ViewChild('fileInput') fileInput: ElementRef;

  public loading = false;
  public invoiceCode: string = '';
  public typeDTE: string = 'FE';
  public cdc: string = '';
  public xmlContent: string = '';
  public cdcFromXml: string = '';
  public signedUrl: string = '';
  public resultMessage: string = '';

  constructor(
    private router: Router,
    private _invoiceService: InvoiceService,
    private _utilsService: UtilsService,
  ) {}

  ngOnInit(): void {
    const state = history.state;
    this.invoiceCode = state.invoiceCode || '';
    this.typeDTE = state.typeDTE || 'FE';
    this.cdc = state.cdc || '';
  }

  async onFileSelected(event: any): Promise<void> {
    const file: File = event.target.files[0];
    if (!file) return;

    if (!file.name.endsWith('.xml')) {
      this._utilsService.showNotification(2, 'Solo se permiten archivos .xml');
      return;
    }

    this.xmlContent = await file.text();
    this.cdcFromXml = this.extractCdcFromXml(this.xmlContent);
    this.signedUrl = '';
    this.resultMessage = '';
  }

  private extractCdcFromXml(xml: string): string {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(xml, 'application/xml');
      const de = doc.getElementsByTagName('DE')[0];
      return de ? (de.getAttribute('Id') || '') : '';
    } catch {
      return '';
    }
  }

  async sendToDnit(): Promise<void> {
    if (!this.xmlContent) {
      this._utilsService.showNotification(2, 'Carga un archivo XML primero');
      return;
    }
    if (!this.invoiceCode) {
      this._utilsService.showNotification(2, 'No se encontró el código de factura');
      return;
    }

    this.loading = true;
    this.signedUrl = '';
    this.resultMessage = '';

    try {
      const body = {
        xml: this.xmlContent,
        typeDTE: this.typeDTE,
        invoiceCode: this.invoiceCode,
      };

      const response = await this._invoiceService.resendDnitPy(body);
      console.log('resendDnitPy response', response);

      if (response.result) {
        this.signedUrl = response.records?.felResponse?.data?.signedUrl || '';
        this.resultMessage = response.message || 'Documento enviado exitosamente';
        swal.fire({
          title: 'Éxito',
          text: this.resultMessage,
          icon: 'success',
          confirmButtonText: 'Aceptar',
          customClass: { confirmButton: 'btn btn-success' },
          buttonsStyling: false,
        });
      } else {
        this.resultMessage = response.message || 'Error al enviar el documento';
        swal.fire({
          title: 'Error',
          text: this.resultMessage,
          icon: 'error',
          confirmButtonText: 'Aceptar',
          customClass: { confirmButton: 'btn btn-danger' },
          buttonsStyling: false,
        });
      }
    } catch (error) {
      console.error('Error enviando a DNIT', error);
      const msg = typeof error === 'string' ? error : 'Error al comunicarse con el servidor';
      swal.fire({
        title: 'Error',
        text: msg,
        icon: 'error',
        confirmButtonText: 'Aceptar',
        customClass: { confirmButton: 'btn btn-danger' },
        buttonsStyling: false,
      });
    } finally {
      this.loading = false;
    }
  }

  clearFile(): void {
    this.xmlContent = '';
    this.cdcFromXml = '';
    this.signedUrl = '';
    this.resultMessage = '';
    if (this.fileInput) this.fileInput.nativeElement.value = '';
  }
}
